import { render } from "./CreateSalesPage.vue?vue&type=template&id=88eef5b0&ts=true"
import script from "./CreateSalesPage.vue?vue&type=script&lang=ts"
export * from "./CreateSalesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__